import { ActionIcon, Group } from "@mantine/core";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
import Text from "@/components/atoms/Text";
import { useTranslation } from "react-i18next";

interface ViewToggleProps {
  showListAsGrid: boolean;
  setShowListAsGrid: (value: boolean) => void;
}
export default function ViewToggle({ showListAsGrid, setShowListAsGrid }: ViewToggleProps) {
  const { t } = useTranslation();

  const svgName = showListAsGrid ? "hamburgerGray" : "gridView";
  const text = showListAsGrid ? t("contracts:viewAsList") : t("contracts:viewAsGrid");
  return (
    <Group justify="right">
      <Text color="secondary">{text}</Text>
      <ActionIcon style={{ backgroundColor: "transparent" }} onClick={() => setShowListAsGrid(!showListAsGrid)}>
        <SVGAsset name={svgName} />
      </ActionIcon>
    </Group>
  );
}
